import { render, staticRenderFns } from "./DataHome.vue?vue&type=template&id=afef240c&scoped=true&"
import script from "./DataHome.vue?vue&type=script&lang=js&"
export * from "./DataHome.vue?vue&type=script&lang=js&"
import style0 from "./DataHome.vue?vue&type=style&index=0&id=afef240c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afef240c",
  null
  
)

export default component.exports